import {getPolygons, TXY} from "@ui/api/features"
import service from "@ui/services/features/PolygonService"
import {LayerId} from "@ui/services/features"
import association from "@ui/services/features/Association"
import {Feature, TFeatureConstructorParams} from "./feature"

type TPolygonConstructorParams = TFeatureConstructorParams

export class Polygon extends Feature {

  constructor(params: TPolygonConstructorParams) {
    super(params)
  }

  async load(coords: TXY): Promise<void> {
    const polygons = await getPolygons(coords)
    association.addAssociations(polygons.associations)
    service.addPolygon(polygons.anchorage_area, LayerId.ACHARE)
  }

  toggle(isVisible: boolean) {
    service.toggleLayer(isVisible)
  }
}
